export const GET_CURRENT_USER = '/v1/account'

// API Endpoints for map
export const GET_PLACES = '/map/places'
export const GET_ALL_TOILETS = '/map/toilets/all/'
export const GEOCODE_POSTCODE = '/geocode/postcode'
export const GEOCODE_REVERSE = '/geocode/reverse'
export const GEOCODE_TIMEZONE = '/geocode/timezone'

// API Endpoints for connectUp data
export const POST_CONTACT_FORM = '/contact/'
export const UPLOAD_FILE = '/assets/upload'

// API Endpoints for account
export const JOIN_USER = '/register/'
export const VERIFY_TOKEN = '/verify-token/'
export const RESEND_ACTIVATION = '/resend-activation/'
export const SET_PASSWORD = '/set-password/'
export const LOGIN = '/login/'
export const LOGOUT = '/logout/'
export const REQUEST_PASSWORD_RESET = '/password-reset/request/'
export const RESET_VERIFY_TOKEN = '/password-reset/verify/'
export const RESET_PASSWORD = '/password-reset/set-password/'

// API Endpoints for validation
export const CHECK_EMAIL_AVAILABILITY = '/validate/check-email/'
export const VALIDATE_POSTCODE = '/validate/postcode/'

export const GET_ACCESS_TOKEN = '/users/get_access_token/'

// get any user's profile without sensitive information
export const GET_USER_PROFILE = '/users/profile/'
export const GET_SELF_PROFILE = '/profiles/'
export const UPDATE_SELF_PROFILE = '/profiles/'
export const UPLOAD_AVATAR = '/profiles/upload-avatar/'
export const DELETE_ACCOUNT = '/profiles/delete-account/'

// API Endpoints for connect
export const GET_POSSIBLE_CONNECTIONS = '/users/possible_connections/'
export const GET_NOT_MATCH_CONNECTIONS = '/users/not_match_connections/'
export const SEND_REQUEST = '/connection/send_request/'
export const RESPOND_REQUEST = '/connection/respond_request/'
// need specify user is receiver or sender, and request status
export const GET_REQUEST_LIST = '/connection/get_list_request/'
// need specify user is receiver or sender
export const GET_ALL_REQUESTS = '/connection/get_all_request/'
// need connection id
export const GET_ONE_CONNECTION = '/connection/get_one/'
export const GET_CONNECTION_STATS = '/connection/stats/'
export const GET_CONNECTIONS = '/connection/get_connected_list/'
export const GET_FRIENDS_LIST = '/connection/get_friends_list/'
export const GET_GROUPS_LIST = '/connection/get_groups_list/'
// need connection id
export const CANCEL_CONNECTION = '/connection/cancel_connection/'
export const GET_CONNECTION_BY_SID = '/connection/get_by_sid/'
export const DELETE_CONNECTION = '/connection/delete_connection/'
export const BLOCK_USER = '/users/block/'
export const UNBLOCK_USER = '/users/unblock/' // append {userId}/
export const LEAVE_GROUP = '/connection/leave_group/'
// invite new members to a group connection (POST)
export const INVITE_MEMBERS = '/connection/invite_members/'
// update group name (PATCH)
export const UPDATE_GROUP_NAME = '/connection/update_group_name/'
// remove member from group (DELETE)
export const REMOVE_MEMBER = '/connection/remove_member/'

// API Endpoints for chat
export const GET_CONVERSATION_ACCESS_TOKEN = '/chat/token'
export const LOG_MESSAGE = '/chat/log_message/'

// API Endpoints for event
export const CREATE_EVENT = '/event/sent_request/'
export const RESPONSE_EVENT = '/event/respond_request/'
export const GET_PENDING_EVENTS = '/event/get_pending/'
export const GET_ACCEPTED_EVENTS = '/event/get_events/'
export const GET_ONE_EVENT = '/event/get_one/'
export const GET_EVENTS_BY_TIME = '/event/get_by_time/'
export const GET_EVENTS_BY_TIME_RANGE = '/event/get_by_time_range/'
export const GET_EVENTS_BY_USER = '/event/get_user_event/'
export const GET_PAST_EVENTS = '/event/get_past_events/'
export const CREATE_CALENDAR_EVENT = '/event/create_calendar_event/'
export const GET_AVAILABLE_FRIENDS = '/event/get_available_friends/'

// API Endpoints for recurring events
export const CREATE_RECURRING_EVENT = '/event/create_recurring_event/'
// Removed unused private event occurrences endpoint

// API Endpoints for event updates
export const UPDATE_PRIVATE_EVENT = '/event/{id}/update_event/'
export const UPDATE_PUBLIC_EVENT = '/public-events/events/{id}/'

// API Endpoints for event deletion
export const DELETE_PRIVATE_EVENT = '/event/{id}/delete_event/'
export const DELETE_PUBLIC_EVENT = '/public-events/events/{id}/'

// API Endpoints for event participants
export const INVITE_PARTICIPANTS = '/event/{id}/invite_participants/'
export const REMOVE_PARTICIPANT = '/event/{id}/remove_participant/{userId}/'

// API Endpoints for marker
export const MARKER_ENDPOINT = '/marker/'

export const GET_PUBLIC_EVENTS_GEOJSON = '/public-events/events/geojson'

// API Endpoints for public event participation
export const JOIN_PUBLIC_EVENT = '/public-events/events/{id}/join/'
export const LEAVE_PUBLIC_EVENT = '/public-events/events/{id}/leave/'
export const GET_PUBLIC_EVENT_PARTICIPANTS = '/public-events/events/{id}/participants/'
export const GET_USER_PUBLIC_EVENTS = '/public-events/events/my_events/'
export const GET_RECOMMENDED_EVENTS = '/public-events/events/recommended/'
